import assetPath from '@uikit/helpers/assetPath';

export const NOT_AVAILABLE_INFO_TITLE = 'Neue Aktionen sind im Anflug!';
export const NOT_AVAILABLE_INFO_DESCRIPTION =
  'Wir überarbeiten gerade unser Angebot. Wir freuen uns, wenn Sie demnächst nochmal reinschauen.';
export const SOON_AVAILABLE_ICON = {
  path: `${assetPath}/assets/benefits/calendar.svg`,
  name: 'Bald verfügbar',
};
